module.exports = __webpack_public_path__ + "media/images/emblems/Neuheim-Blazono-41e89d8cc34edf1875e48523ae41bd94.png";